import React, { useEffect, useState } from "react";
import { api } from "api/apiService";

// Універсальний компонент для вставки звітів
const EmbeddedReportPage = ({ pageTitle, iframeTitle, endpointUrl }) => {
  const [embedUrl, setEmbedUrl] = useState("");
  const [error, setError] = useState(null);

  // Стан для зберігання поточної теми
  const [currentTheme, setCurrentTheme] = useState(
    document.documentElement.getAttribute("data-theme") || "light",
  );

  // Слідкуємо за зміною атрибута data-theme (щоб iframe оновлювався без перезавантаження)
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const newTheme = document.documentElement.getAttribute("data-theme") || "light";
      if (newTheme !== currentTheme) {
        setCurrentTheme(newTheme);
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, [currentTheme]);

  // Отримуємо URL з бекенду (зверни увагу, currentTheme додано в масив залежностей)
  useEffect(() => {
    if (!endpointUrl) {
      setError("URL ендпоінту не було надано компоненту.");
      return;
    }

    const fetchEmbedUrl = async () => {
      setError(null);
      try {
        // Додаємо параметр ?theme=dark або ?theme=light до запиту
        const separator = endpointUrl.includes("?") ? "&" : "?";
        const urlWithTheme = `${endpointUrl}${separator}theme=${currentTheme}`;

        const data = await api.get(urlWithTheme);
        setEmbedUrl(data.embedUrl);
      } catch (err) {
        console.error(`Помилка отримання URL з ${endpointUrl}:`, err);
        setError(
          err.message || "Не вдалося завантажити звіт. Спробуйте оновити сторінку.",
        );
      }
    };

    fetchEmbedUrl();
  }, [endpointUrl, currentTheme]);

  return (
    <section className="embedded-report-page">
      {error && <div className="error-message">{error}</div>}
      {!error && embedUrl && (
        <div className="dashboard-container">
          <iframe
            src={embedUrl}
            title={iframeTitle || pageTitle || "Вбудований звіт"}
            allowTransparency
          ></iframe>
        </div>
      )}
    </section>
  );
};

export default EmbeddedReportPage;
